/**
 * Created by AlexanderC on 5/22/15.
 */

'use strict';

var _Framework = require('./Framework');

var _deepAsset = require('deep-asset');

var _deepAsset2 = _interopRequireDefault(_deepAsset);

var _deepCache = require('deep-cache');

var _deepCache2 = _interopRequireDefault(_deepCache);

var _deepSecurity = require('deep-security');

var _deepSecurity2 = _interopRequireDefault(_deepSecurity);

var _deepResource = require('deep-resource');

var _deepResource2 = _interopRequireDefault(_deepResource);

var _deepLog = require('deep-log');

var _deepLog2 = _interopRequireDefault(_deepLog);

var _deepEvent = require('deep-event');

var _deepEvent2 = _interopRequireDefault(_deepEvent);

var _deepValidation = require('deep-validation');

var _deepValidation2 = _interopRequireDefault(_deepValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @todo - fix lodash error "Uncaught TypeError: Cannot read property 'prototype' of undefined" in runInContext method
//import DeepSearch  from 'deep-search';
//import DeepNotification from 'deep-notification';

module.exports = new _Framework.Framework({
  Asset: _deepAsset2.default,
  Cache: _deepCache2.default,
  Security: _deepSecurity2.default,
  Resource: _deepResource2.default,
  Log: _deepLog2.default,
  Validation: _deepValidation2.default,
  Event: _deepEvent2.default

  //Search: DeepSearch,
  //Notification: DeepNotification,
}, _Framework.Framework.FRONTEND_CONTEXT);


//////////////////
// WEBPACK FOOTER
// ./browser-bootstrap.js
// module id = 246
// module chunks = 0